var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRightLmb = function SvgArrowRightLmb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.51 12.511a1 1 0 0 1-.23.64l-5 6a1.001 1.001 0 1 1-1.54-1.28l4.48-5.36-4.32-5.36a1 1 0 0 1 .15-1.41 1 1 0 0 1 1.46.14l4.83 6a1 1 0 0 1 .17.63"
  })));
};
export default SvgArrowRightLmb;